import React from "react";
import { IonSpinner } from "@ionic/react";
import { useTranslation } from "react-i18next";

interface SubmitButtonProps {
  isValid: boolean;
  isLoading: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isValid, isLoading }) => {
  const { t } = useTranslation();
  return (
    <button
      type="submit"
      color="secondary"
      disabled={!isValid || isLoading}
      className="rounded-2xl py-2 disabled:opacity-60 bg-[var(--ion-color-secondary)] text-white"
    >
      {isLoading ? <IonSpinner name="crescent" className="w-4 h-4" /> : t("Submit")}
    </button>
  );
};

export default SubmitButton;
